interface BrandLockupProps {
  caption?: string;
  className?: string;
  size?: "standard" | "large";
}

/**
 * The same visual lockup used by the public Arikekpar & Company website:
 * waveform mark, full firm name on one line, then a quiet descriptor.
 * Keeping it as one component prevents the name being re-typeset differently
 * from screen to screen.
 */
export function BrandLockup({
  caption = "Your dreams, our voice",
  className = "",
  size = "standard",
}: BrandLockupProps) {
  const large = size === "large";

  return (
    <span className={`flex items-center ${large ? "gap-4" : "gap-3"} ${className}`.trim()}>
      <img
        src="/logo-mark.png"
        alt=""
        className={`${large ? "h-12 w-16" : "h-10 w-14"} shrink-0 object-contain brightness-0 invert`}
      />
      <span className="min-w-0 leading-none">
        <span
          className={`block whitespace-nowrap font-sans font-medium uppercase text-white ${
            large
              ? "text-xs tracking-[0.18em]"
              : "text-[0.6875rem] tracking-[0.15em]"
          }`}
        >
          Arikekpar &amp; Company
        </span>
        <span
          className={`mt-2 block whitespace-nowrap font-sans uppercase text-white/55 ${
            large
              ? "text-[0.625rem] tracking-[0.22em]"
              : "text-[0.5625rem] tracking-[0.19em]"
          }`}
        >
          {caption}
        </span>
      </span>
    </span>
  );
}
